import { BANKS } from "../../utils/bankConstants";

const ACCOUNT_TYPES = [
  { id: 1, label: "Cuenta Corriente" },
  { id: 2, label: "Cuenta de Ahorros" },
  { id: 3, label: "Efectivo", disabled: true },
  { id: 4, label: "Número de Celular" },
];

const Row = ({ label, value, mono = false }) => (
  <div className="ui-kv__row">
    <span className="ui-kv__label">{label}</span>
    <span className={`ui-kv__value${mono ? " ui-kv__value--mono" : ""}`}>{value ?? "-"}</span>
  </div>
);

export const CardUserOrder = ({ order }) => {
  const user = order.user_id || {};
  const bank = user.bankAccount;
  const hasBank = bank?.accountType && bank?.bankCode && bank?.accountNumber;

  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 15 }}>
        <i className="ri-user-line" style={{ color: "#4B36F0", fontSize: 16 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Cliente</h3>
      </div>
      <div className="ui-kv">
        <Row label="Código" value={user.multyhealth_code} mono />
        <Row label="Documento" value={user.document} mono />
        <Row label="Nombre" value={user.name} />
        <Row label="Teléfono" value={user.cellphone} />
        <Row label="Correo" value={user.email} />
        <Row
          label="Registrado en"
          value={user.createdAt ? new Date(user.createdAt).toLocaleDateString() : "-"}
        />
        {hasBank ? (
          <>
            <Row label="Tipo de cuenta" value={ACCOUNT_TYPES.find((t) => t.id == bank.accountType)?.label} />
            <Row label="Banco" value={BANKS.find((b) => b.id == bank.bankCode)?.name} />
            <Row label="Número de cuenta" value={bank.accountNumber} mono />
          </>
        ) : (
          <Row label="Datos bancarios" value="No registrados" />
        )}
      </div>
    </div>
  );
};
